import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { requestHideDialogLoader, requestShowDialogLoader } from "../Store/Global/action";
import { getDocumentBlob } from "../Utility/apiHelper";
import { getFileTypeIcon } from "../Utility/fileIconUtils";
import { getMimeFromFile } from "../Utility/calculations";

const DocumentViewer = ({ documentId, fileName }) => {
  const dispatch = useDispatch();
  const [url, setUrl] = useState(null);
  const [mime, setMime] = useState("");

  useEffect(() => {
    let objectUrl;

    const load = async () => {
      dispatch(requestShowDialogLoader());
      try {
        const res = await getDocumentBlob(documentId);
        const type =
          res.headers["content-type"] !== "application/octet-stream"
            ? res.headers["content-type"]
            : getMimeFromFile(fileName);

        objectUrl = URL.createObjectURL(new Blob([res.data], { type }));
        setMime(type);
        setUrl(objectUrl);
      } finally {
        dispatch(requestHideDialogLoader());
      }
    };

    load();
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, [documentId]);

  if (mime.startsWith("image/")) {
    return (
      <img
        src={url}
        alt={fileName}
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
      />
    );
  }

  return <span>{getFileTypeIcon(fileName?.split(".").pop())}</span>;
};

export default DocumentViewer;
